import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingService } from '../../../core/services/loading.service';

/**
 * Global API loading overlay.
 * Displays a spinning green ring whenever at least one tracked HTTP request
 * is in-flight (including login, invite, and MFA).
 *
 * Mounted once at the root app level.
 */
@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [CommonModule],
  template: `
    @if (loading.isLoading()) {
      <div class="loader-backdrop" aria-label="Loading" role="status">
        <div class="loader-ring"></div>
      </div>
    }
  `,
  styles: [`
    .loader-backdrop {
      position: fixed;
      inset: 0;
      z-index: 99999;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(255, 255, 255, 0.55);
      backdrop-filter: blur(3px);
      animation: loaderFadeIn 0.12s ease;
    }

    @keyframes loaderFadeIn {
      from { opacity: 0; }
      to   { opacity: 1; }
    }

    /* The green "C" ring — border trick: 3 sides green, 1 transparent */
    .loader-ring {
      width: 52px;
      height: 52px;
      border-radius: 50%;
      border: 5px solid transparent;
      border-top-color:    #2ecc91;
      border-right-color:  #2ecc91;
      border-bottom-color: #2ecc91;
      /* left side transparent to create the "gap" matching the image */
      animation: loaderSpin 0.75s cubic-bezier(0.4, 0, 0.2, 1) infinite;
    }

    @keyframes loaderSpin {
      0%   { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `]
})
export class AppLoaderComponent {
  readonly loading = inject(LoadingService);
}
